import React, { Component, useState } from 'react'

import { connect, batch } from 'react-redux';
import { styles, WhiteButton } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles, Typography, Divider } from '@material-ui/core';


import { withRouter } from 'react-router';
import { getLocationPathName } from '../../selectors/util.selector';
import { DatePicker } from "material-ui-pickers";
import moment, { Moment } from 'moment'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { isPrintBoardOpen } from '../../selectors/phaseplan.selector';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'

import Button from '@material-ui/core/Button';
import { dialogActions } from '../../actions/dialog.actions';
import { ThunkDispatch } from 'redux-thunk';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { lookaheadActions } from '../../actions/lookahead.actions';
import { alertActions } from '../../actions/alert.actions'
import { getCommitmentDay, getLookaheadTrades, getMinCommitmentDate, getReportData, getReportViewTradeId, isReportDialogOpen } from '../../selectors/lookahead.selector';
import DayPicker from '../DayPicker';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton'
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import classNames from 'classnames';
import { Report } from '../../models/Report';
import { Trade } from '../../models/Trade';
import Chip from '@material-ui/core/Chip';
import { getProject, getProjectId } from '../../selectors/project.selector';
import { withFirebase } from 'react-redux-firebase';

interface Props {
    isReportDialogOpen: boolean;
    closeDialogValue: () => void;
    classes: ClassNameMap,
    errorAlert: (message:string) => void;
    report: Report;
    trades: Record<string, Trade>
    tradeId: string,
    projectId: string
}

type State = {
  fileUrl: string
}



class ReportViewDialog extends Component<Props, State> {
    constructor(props:Props) {
        super(props)

        this.state = {
            
        }
    }


    closeDialog = async () => {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }






    onEnter = () => {
        
    }

    getTradeName = () => {
        const { report, trades, tradeId } = this.props

        if(!report || !trades) {
            return "e"
        }

        const trade = trades[tradeId]

        if(!trade) {
            return "d"
        }

        return trade.name


    }

    getReportConstraint = () => {
        const { report } = this.props
        console.log('getReportConstraint', report)
        const constraints = !!report?.constraints ? report?.constraints : {}

        return Object.keys(constraints).map(constraintId => {
            const constraint = constraints[constraintId]
            return <Chip label={`${constraint.description} due ${constraint.dueDate}`} />
        })
    }

    getReportDeliveries = () => {
        const { report } = this.props
        const deliveries = !!report?.deliveries ? report?.deliveries : {}

        return Object.keys(deliveries).map(deliveryId => {
            const delivery = deliveries[deliveryId]
            return delivery
            
        }).join(',')
    }

    getReportTasks = () => {
        const { report } = this.props
        const tasks = !!report?.tasks ? report?.tasks : {}

        return Object.keys(tasks).map(taskId => {
            const task = tasks[taskId]
            return <Chip label={`${task.name} with crew size ${task.crew} at ${task.location}`} />
            
        })
    }

    getReportQuestions = () => {
        const { report } = this.props
        const questions = !!report?.questions ? report?.questions : {}

        return Object.keys(questions).map(questionId => {
            const question = questions[questionId]
            return question
            
        }).join(',')
    }

    componentDidUpdate(prevProps: AreaItemProps, prevState: AreaItemState) {
        const { report } = this.props
        if (!!report?.zone) {
            this.loadThumbnail()
        }
    }


    loadThumbnail = async () => {
        const {  report, projectId } = this.props

        const entityRoute = `/zones/projects/${projectId}/areas/${report?.zone?.areaId}/zones/${report?.zone?.zoneId}.png`

        const storageRef = this.props.firebase.storage().ref().child(`${entityRoute}`)



        const downloadUrl = await storageRef.getDownloadURL()


        this.setState({
            fileUrl: downloadUrl
        })
    }



    render() {
        const { classes, report } = this.props;
        const { fileUrl } = this.state
        

        return (
            <Dialog
                PaperProps={{
                    style: {
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                    },
                }}
                fullScreen={true}
                open={!!this.props.isReportDialogOpen}
                onEnter={this.onEnter}
                onBackdropClick={this.closeDialog.bind(this)}
            >
                    <div className={classNames(classes.FullScreenContainer)}>
                        <div style={{backgroundColor: '#3973BE'}} className={classNames(classes.FullScreenTop)}>
                            <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                        <p className={classNames(classes.FullScreenTopTitle)}>
                                            {this.getTradeName()}
                                        </p>
                                        <p className={classNames(classes.SixteenMarginLeft, classes.FullScreenTopSubTitle)} >
                                            {report?.location}
                                        </p>
                                    </div>
                                    <p className={classNames(classes.FullScreenTopSubTitle)} >
                                        {moment(report?.date,'MM-DD-YYY').format('l')}
                                    </p>
                                </div>
                                <div>
                                    <IconButton onClick={this.props.closeDialogValue} style={{marginLeft: '48px', marginRight: '32px'}}>
                                        <CloseIcon style={{height: '24px', width: '24px', color: '#fff'}} />
                                    </IconButton>
                                </div>
                            </div>
                    </div>
                    <div className={classNames(classes.FullScreenBottom)}>
                            <div style={{width: '75%', height: '100%', borderRadius: '2%', backgroundColor: '#fff', paddingLeft: 30, paddingTop: 30, overflowY: 'scroll'}}>
                                <Typography style={{color: '#2488FE', fontWeight: 600, fontSize: 24}}>
                                    Report
                                </Typography>
                                <div style={{flexDirection: 'row', display: 'flex'}}>
                                    <div style={{marginTop: 32, width: '75%', overflowY: 'scroll'}}>
                                        <div className={classNames(classes.ReportViewRow)}>
                                            <div className={classes.ReportNumber}>
                                                <p className={classes.ReportNumberBackground}>1</p>
                                            </div>
                                            
                                            <div>
                                                <p className={classes.ReportQuestion}>What are you working on today?</p>
                                                <p className={classes.ReportAnswer}>{report?.goal}</p>
                                            </div>
                                        </div>
                                        <div className={classNames(classes.ReportViewRow)}>
                                            <div className={classes.ReportNumber}>
                                                <p className={classes.ReportNumberBackground}>2</p>
                                            </div>
                                            
                                            <div>
                                                <p className={classes.ReportQuestion}>Where are you working?</p>
                                                <p className={classes.ReportAnswer}>{report?.location}</p>
                                            </div>
                                        </div>
                                        <div className={classNames(classes.ReportViewRow)}>
                                            <div className={classes.ReportNumber}>
                                                <p className={classes.ReportNumberBackground}>3</p>
                                            </div>
                                            
                                            <div>
                                                <p className={classes.ReportQuestion}>What are your constraints?</p>
                                                <p className={classes.ReportAnswer}>{this.getReportConstraint()}</p>
                                            </div>
                                        </div>
                                        <div className={classNames(classes.ReportViewRow)}>
                                            <div className={classes.ReportNumber}>
                                                <p className={classes.ReportNumberBackground}>4</p>
                                            </div>
                                            
                                            <div>
                                                <p className={classes.ReportQuestion}>How many people are in you crew?</p>
                                                <p className={classes.ReportAnswer}>{report?.crew}</p>
                                            </div>
                                        </div>
                                        <div className={classNames(classes.ReportViewRow)}>
                                            <div className={classes.ReportNumber}>
                                                <p className={classes.ReportNumberBackground}>5</p>
                                            </div>
                                            
                                            <div>
                                                <p className={classes.ReportQuestion}>What deliveries are you getting?</p>
                                                <p className={classes.ReportAnswer}>{this.getReportDeliveries()}</p>
                                            </div>
                                        </div>
                                        <div className={classNames(classes.ReportViewRow)}>
                                            <div className={classes.ReportNumber}>
                                                <p className={classes.ReportNumberBackground}>6</p>
                                            </div>
                                            
                                            <div>
                                                <p className={classes.ReportQuestion}>What are your tasks today?</p>
                                                <p className={classes.ReportAnswer}>{this.getReportTasks()}</p>
                                            </div>
                                        </div>
                                        <div className={classNames(classes.ReportViewRow)}>
                                            <div className={classes.ReportNumber}>
                                                <p className={classes.ReportNumberBackground}>7</p>
                                            </div>
                                            
                                            <div>
                                                <p className={classes.ReportQuestion}>What are your parking lot questions?</p>
                                                <p className={classes.ReportAnswer}>{this.getReportQuestions()}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {!!report?.zone && <div style={{width: '25%', flexDirection: 'column'}}>
                                        <p>Zone</p>
                                        <div onClick={()=> window.open(fileUrl, "_blank")} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f6f6f6', borderRadius: 8, width: 200, height: 200}}>
                                            <img style={{ width: 180, height: 180,   'object-fit': 'contain'}} src={fileUrl} />

                                        </div>
                                    </div>}
                                </div>
                            </div>
                    </div>
                    </div>

            </Dialog>
        )
    }
}

const mapStateToProps = (state:any) => ({
    isReportDialogOpen: isReportDialogOpen(state),
    trades: getLookaheadTrades(state),
    report: getReportData(state),
    tradeId: getReportViewTradeId(state),
    projectId: getProjectId(state)

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(lookaheadActions.closeReportDialog()),
        errorAlert: (message:string) => dispatch(alertActions.error(message)),
    }
};


export default compose<React.ComponentClass>(
    withRouter,
    withFirebase,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
)(ReportViewDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/ReportViewDialog.tsx